import React, { useMemo, type FC, Suspense } from 'react'
import { Outlet, useMatches } from 'react-router-dom'
import RootLayout from './components/layout'
import { menuList } from './routes/menuLIst.config'
import { ConfigProvider, App as AntdApp, message } from 'antd'
import { Provider as ReduxProvider } from 'react-redux'
import { PersistGate } from 'reduxjs-toolkit-persist/integration/react'
import store, { persistor } from '@/store'
import zhCN from 'antd/locale/zh_CN'
import { GlobalStyle } from './styles/global'
import { ThemeProvider } from 'styled-components'
import { theme } from '@/config/theme'
import { messageConfig } from './config/antdConfig'
import 'dayjs/locale/zh-cn'
message.config(messageConfig)

const App: FC = () => {
  const matches = useMatches()

  const haveLayout = useMemo(() => {
    return matches.some((item) => {
      const id = item.id
      return menuList.some((menu) => menu.id === id && menu.layout !== false)
    })
  }, [matches])

  const Dom = useMemo(() => {
    if (haveLayout) {
      return (
        <RootLayout>
          <Outlet />
        </RootLayout>
      )
    }
    return <Outlet />
  }, [haveLayout])

  return (
    <ReduxProvider store={store}>
      <PersistGate loading={<>loading</>} persistor={persistor}>
        <Suspense>
          <ConfigProvider locale={zhCN}>
            <AntdApp>
              <ThemeProvider theme={theme}>
                <GlobalStyle />
                {Dom}
              </ThemeProvider>
            </AntdApp>
          </ConfigProvider>
        </Suspense>
      </PersistGate>
    </ReduxProvider>
  )
}

export default App
